import { render, staticRenderFns } from "./campana.vue?vue&type=template&id=5c9bca04&scoped=true"
import script from "./campana.vue?vue&type=script&lang=ts"
export * from "./campana.vue?vue&type=script&lang=ts"
import style0 from "./campana.vue?vue&type=style&index=0&id=5c9bca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9bca04",
  null
  
)

export default component.exports